// extracted by mini-css-extract-plugin
export default {"wrapper":"LinkPlace_wrapper__JLc4w","item":"LinkPlace_item__zDOI4","label":"LinkPlace_label__-AlEv"};